import React from 'react'

const BlockIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5241 3.13968L11.798 0.441678L11.6807 0.342087C11.0398 -0.164919 10.1371 -0.101543 9.56842 0.486946L7.58252 2.55119V2.38822C7.50128 1.57339 6.82427 0.957738 6.00283 0.957738H1.42624C0.613823 1.04827 0 1.7273 0 2.54213V13.5695C0.0812413 14.3843 0.758252 15 1.57969 15H12.5744C13.3868 14.9185 14.0006 14.2395 14.0006 13.4156V8.81633C13.9193 8.01056 13.2514 7.39491 12.4389 7.38585L14.5422 5.37593L14.6505 5.25824C15.165 4.62448 15.1019 3.71006 14.5241 3.13968ZM12.809 13.4066V13.488C12.7729 13.6782 12.6014 13.814 12.4119 13.814H7.58252V8.57188H12.4841C12.6736 8.6081 12.809 8.77107 12.809 8.97025V13.4066ZM7.59155 7.38585V5.95537L9.01779 7.38585H7.59155ZM10.435 7.13235L7.86235 4.55205L7.80819 4.47962C7.7089 4.32571 7.72695 4.11747 7.85333 3.99072L10.426 1.31083L10.4892 1.25651C10.5614 1.21124 10.6336 1.18408 10.7148 1.18408C10.7961 1.18408 10.9224 1.22029 10.9947 1.30178L13.6937 3.97261L13.7478 4.03599C13.8562 4.1899 13.8381 4.40719 13.7117 4.53394L11.0037 7.1233L10.9315 7.17762C10.778 7.27721 10.5704 7.25005 10.444 7.1233L10.435 7.13235ZM1.18251 13.4156V8.57188H6.40904V13.814H1.58872H1.5165L1.44429 13.7959C1.29083 13.7415 1.19154 13.5876 1.19154 13.4247L1.18251 13.4156ZM6.40904 2.54213V7.38585H1.18251V2.55119V2.4697C1.21862 2.27958 1.3811 2.14377 1.57067 2.14377H6.06602L6.13823 2.15282C6.29169 2.20715 6.40904 2.37917 6.40904 2.54213Z"
        fill="white"
      />
    </svg>
  )
}

export default BlockIcon
